import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import useFormHook from '../hooks/useFormHook';

const DeleteModal = ({ onClose, onConfirm, name, entityType = 'users', message }) => {
    const { modalRef } = useFormHook({}, onClose);
    const { t } = useTranslation();


    const getTranslationKey = () => {
        switch (entityType) {
            case 'country':
                return 'regions.deleteModal.country';
            case 'region':
                return 'regions.deleteModal.region';
            case 'municipality':
                return 'regions.deleteModal.municipality';
            case 'town':
                return 'regions.deleteModal.town';
            case 'schools':
                return 'nav.schools.deleteModal';
            case 'degrees':
                return 'education.deleteModal';
            case 'persons':
                return 'persons.deleteModal';
            case 'record':  // Add this new case
                return 'common.deleteModal.record';
            case 'users':
            default:
                return 'users.deleteModal';
        }
    };

    const translationKey = getTranslationKey();
    const deleteMessage = message
        || t(`${translationKey}.message`).replace('{name}', name ?? '');

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm delete-modal" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="modal-body">
                        <div className="icon-box">
                            <FontAwesomeIcon icon={faTimes} />
                        </div>
                        <h4 className="modal-title">
                            {t(`${translationKey}.title`)}
                        </h4>
                        <p className="delete-message">
                            {deleteMessage}
                        </p>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-danger" onClick={onConfirm}>
                            {t(`${translationKey}.confirm`)}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t(`${translationKey}.cancel`)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;